import { httpApi } from '@api/http.api';

export interface PasswordPolicy {
    id: number;
    name: string;
    description: string;
    regexPattern: string;
    passwordRequirementType: string;
    passwordRequirementValue: number;
    createdAtUTC: string;
    updatedAtUTC: string;
}

export interface PwSession {
    crewPasswordPolicies: PasswordPolicy[];
    officePasswordPolicies: PasswordPolicy[];
}

export interface UpdatePwSessionRequest {
    crewPasswordPolicies: {
        id: number;
        passwordRequirementValue: number;
    }[];
    officePasswordPolicies: {
        id: number;
        passwordRequirementValue: number;
    }[];
}

export const getApiPwSession = (clientId: number, tenantAlias: string): Promise<PwSession> =>
    httpApi
        .get<PwSession>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/password-policies`)
        .then(({ data }) => data);

export const updateApiPwSession = (
    clientId: number,
    tenantAlias: string,
    payload: UpdatePwSessionRequest,
): Promise<string> =>
    httpApi
        .put<string>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/password-policies`, payload)
        .then(({ data }) => data);
